/**
 * RESPONSIBILITY: a sermon's address.
 *
 * `#sermons/<url>`: the server makes `url` unique from the title (see
 * SermonsSection.prepare), so a link shared today still works after the list grows.
 */
import type { SermonRow } from '@app/sections';
import { Page, hrefFor } from '../commons/pages';
import { keyOf } from '../commons/slug';

export const sermonHref = (s: SermonRow): string => hrefFor(Page.Sermons, keyOf(s));
